<script>
    import Average from "./Average.svelte";
	import { upperInitial } from "./parse.js";

    export let textSize = 3
    export let inline = true;
	export let visible = true;
	export let clickable = false;
	export let selectable = false;

    let details = false;
    //console.log(state.cardsByID, id);
    export let a;
	let showAvg = false;

    function showDetails(){

    }

    function possiblyToggle(){

    }

</script>
    <button class="card {a ? a.name.replaceAll(/ /g, '_') : ''}" class:hidden={!visible} style={"--text-size: "+textSize+"vmin;"+(inline ? " display: inline-flex; vertical-align: middle;": "")} on:click={e => { if(clickable) showDetails(); if(selectable) possiblyToggle(c); } }>
        {#if a && visible}
            {upperInitial(a.name)}
			<div class="cardscore" style="cursor: pointer;" on:click={e => {showAvg = !showAvg}}><div>
				{#if showAvg}
					ø <Average data={a.byTurn} digits=1 />
				{:else}
					{a.count} 
				{/if}
			</div></div>
		{:else if a && !visible}
			Hidden
        {:else}
            No card
        {/if}
    </button>
<style>

	.card {
		font-size: var(--text-size);
		margin: 0.5vmin;
		height: calc(2vmin + var(--text-size));
		display: flex;
		align-items: center;
		white-space: nowrap;
		cursor: pointer;
		touch-action: manipulation;
		border: 1px solid #ccc;
		border-radius: 2vmin;	
	}

	.card.selected {
		background-color: orange;
		color: black;
		border: 0.5vmin dashed red;
	}

	.card.hidden {
		background-color: blue;
		color: red;
	}

	.cardscore {
		font-size: var(--text-size);
		background-color: orange;
		height: var(--text-size);
		min-width: var(--text-size);
		display: flex;
		align-items: center;
		font-weight: bold;
		color: black;
		border-radius: 50%;
		border: 0.1vmin solid black;
		padding: 0.2vmin;
		margin: 0.5vmin;
		text-shadow: none;
	}

	.cardscore > div {
		text-align: center;
		width: 100%;
	}

    .triangle {
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 6vmin 0 0 6vmin;
	}

	.triangle_small {
		width: 0;
		height: 0;
		border-style: solid;
		border-width: var(--text-size) 0 0 var(--text-size);
	}

	.gain_card {
		background-color: #FCC49D;
		border: 0.5vmin solid #DB9B77;
	}
	
	.gain_tokens {
		background-color: #55C1EF;
		border: 0.5vmin solid #62A8C2;
	}

	.gain_on_track {
		background-color: #7586C3;
		border: 0.5vmin solid #616C8D;
	}
	
	.junk {
		background-color: #CBBDDD;
		border: 0.5vmin solid #AC92C2;
	}

	.take_control {
		background-color: #352239;
		color: white;
		border: 0.5vmin solid #D2BAD4;
	}

	.take_incident {
		background-color: #E1706A;
		border: 0.5vmin solid #E94750;
	}

	.take_encounter {
		background-color: #ECDAD6;
		border: 0.5vmin solid #EEC1BD;
	}

</style>